import { AfterViewInit, Component, inject } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Asset, RelatedAsset } from '@app/core/model/entities/asset/asset';
import { SECTION_ENTITY_TYPE_INJECTION } from '@app/core/model/other/field-config';
import { AssetsService } from '@app/features/main/views/assets/assets.service';
import {
  MatSelectEntityAutocompleteServerComponent
} from '@app/shared/components/mat-select-autocomplete/mat-select-entity-autocomplete/mat-select-entity-autocomplete-server/mat-select-entity-autocomplete-server.component';
import { eq } from '@app/shared/extra/filter-model-builder';
import { SelectParams } from '@app/shared/grid/datasource-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'mat-select-asset-autocomplete',
  styleUrls: ['../mat-select-entity-autocomplete.component.scss'],
  templateUrl: '/mat-select-entity-autocomplete-server.component.html',
  providers: [
    {provide: MatFormFieldControl, useExisting: MatSelectAssetAutocompleteComponent}
  ],
  standalone: false
})
export class MatSelectAssetAutocompleteComponent extends MatSelectEntityAutocompleteServerComponent<RelatedAsset, Asset> implements AfterViewInit {
  private readonly sectionEntityType = inject<EntityTypeEnum>(SECTION_ENTITY_TYPE_INJECTION, {optional: true});
  private readonly assetsService = inject(AssetsService);

  /**
   * Load assets next page.
   * @param startingIndex Page to load. NB: First page is 0.
   * @return Observable<RelatedAsset[]> A list of RelatedAsset matching the form filters.
   */
  public loadEntitiesNextPage(startingIndex: number): Observable<RelatedAsset[]> {
    const params = {...this.buildSelectParams(), start: startingIndex};
    return this.assetsService.loadAssetsPage(params, false)
      .pipe(map(relatedAssets => relatedAssets.map(asset => asset.toRelatedAsset())));
  }

  /**
   * Build Select Params with filters on typeModules and according to the current form.
   * @return SelectParams
   */
  protected buildSelectParams(): SelectParams {
    const selectParams = super.buildSelectParams();
    const assetSheetModuleCodes = [
      EntityTypeEnum.SPACE,
      EntityTypeEnum.CHECK,
      EntityTypeEnum.LEASE,
      EntityTypeEnum.CONTRACT,
      EntityTypeEnum.WORK,
      EntityTypeEnum.EQUIPMENT,
      EntityTypeEnum.VIRTUAL_TOUR,
      EntityTypeEnum.ASSET_CRV,
      EntityTypeEnum.PROJECT,
      EntityTypeEnum.INVESTMENT
    ];
    if (assetSheetModuleCodes.includes(this.sectionEntityType)) {
      selectParams.filters.push(eq('computedProperties.typeModules', this.sectionEntityType));
    }
    return selectParams;
  }
}
